import React from 'react';
import { Box, IconButton } from '@mui/material';
import { components } from 'react-select';
import xIcon from '../../assets/icons/x.svg';

/**
 * Custom DropdownIndicator for multiselects
 * Shows blue X (clear all) and chevron when there's a value
 */
export const CustomDropdownIndicator = ({ hasValue, onClear, isMulti, ...props }) => {
  // For multiselect with values, show both X (clear all) and chevron (dropdown toggle)
  if (isMulti && hasValue && onClear) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <IconButton
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            onClear();
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          sx={{
            padding: '4px',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <img 
            src={xIcon} 
            alt="Clear" 
            style={{ 
              width: '18px', 
              height: '18px',
              filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(200deg) brightness(104%) contrast(97%)'
            }} 
          />
        </IconButton>
        <components.DropdownIndicator {...props} />
      </Box>
    );
  }
  
  return <components.DropdownIndicator {...props} />;
};

/**
 * ValueContainer for multiselects
 * Shows "Label: X sélectionnées" format instead of individual tags
 */
export const MultiselectValueContainer = ({ children, label, getValue, countColor = '#007BC6', ...props }) => {
  // getValue might be a function or passed via props
  const getValueFn = getValue || props.getValue;
  const count = Array.isArray(getValueFn?.()) ? getValueFn().length : 0;
  
  if (count === 0) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  }
  
  return (
    <components.ValueContainer {...props}>
      <div style={{ 
        fontSize: '16px', 
        fontWeight: 600, 
        fontFamily: 'Montserrat, sans-serif',
        display: 'flex',
        alignItems: 'center'
      }}>
        {label && <span style={{ color: '#38485C' }}>{label}:&nbsp;</span>}
        <span style={{ color: countColor }}>{count} {count === 1 ? 'sélectionnée' : 'sélectionnées'}</span>
      </div>
    </components.ValueContainer>
  );
};

export const MultiselectOption = (props) => {
  const { children, isSelected } = props;
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {isSelected && (
          <span style={{ 
            color: '#027BC6', 
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '1'
          }}>✓</span>
        )}
        {!isSelected && (
          <span style={{ 
            width: '16px',
            height: '16px',
            display: 'inline-block'
          }}></span>
        )}
        <span>{children}</span>
      </div>
    </components.Option>
  );
};

